import { render, staticRenderFns } from "./MainData.vue?vue&type=template&id=48f81edc&"
import script from "./MainData.vue?vue&type=script&lang=js&"
export * from "./MainData.vue?vue&type=script&lang=js&"
import style0 from "./MainData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports